import axios from './axios'


export function getMailList (options) {
  //获取站内信
  return axios.get('/api/v1/web/letter/get_all_mail', options);
}

export function getCorperateKnowledge (options) {
  //获取公司见闻
  return axios.get('/api/v1/web/japan_treatment/company_news_list?page=' + options.page);
}

export function getCorperateKnowledgeDetail (options) {
  //获取公司见闻详情
  return axios.get('/api/v1/web/japan_treatment/company_news_list/get_info?id=' + options.id);
}

export function getCountry (options) {
  //获取国家
  return axios.get('/api/v1/web/japan_treatment/state_list', options)
}
export function getServiceTypes (options) {
  //获取服务类型
  return axios.get('/api/v1/web/japan_treatment/search_item', options)
}
// export function getCity(options){
//     //获取地区
//     return axios.get('/api/v1/web/japan_treatment/area_list',options)
// }
// export function getDepartment(options){
//     //获取科室
//     return axios.get('/api/v1/web/japan_treatment/department_list',options)
// }
// export function getDisease(options){
//     //获取疾病列表
//     return axios.get('/api/v1/web/cases/disease_list',options)
// }   



export function submitFormData (options) {
  //医院表单提交
  // return axios({
  //     url: '/api/v1/web/user_form/sort',
  //     method: 'post',
  //     data: {
  //         content: options.content,
  //         hospital_id: options.hospital_id
  //     },
  //     headers:{
  //         'Content-Type': 'multipart/form-data'
  //     }
  // })
  return axios.post('/api/v1/web/user_form/sort', options, { headers: { 'Content-Type': 'application/json' } })
}
export function getFormTablePart (options) {
  //获取第二个表单动态部分
  return axios.get('/api/v1/web/japan_treatment/form_plan_project?id=' + options.id)
}
export function getUserAgreementsRuls (options) {
  return axios.get('/api/v1/web/user_form/user_consent_form?id=' + options.id);
}

//国际医疗
export function getOtherCountries (options) {
  //其他国家
  return axios.get('/api/v1/web/japan_treatment/countries_list', options)
}
export function getSuccessCaseList (options) {
  //其他国家
  return axios.get('/api/v1/web/cases/cases_list/', options)
}

//问题反馈表单
export function submitProblem (options) {
  //提交表单
  return axios.post('/api/v1/web/user_form/problem_form', options, { headers: { 'Content-Type': 'application/json' } })
}

//获取表单节点
export function getFormStepNow (options) {
  return axios.get('/api/v1/web/user_form/form_status?form_id=' + options.form_id)
}

//疾病专题
export function diseaseList (options) {
  return axios.get('/api/v1/web/cases/project_list')
}
//疾病专题详情
export function diseaseDetail (options) {
  return axios.get('/api/v1/web/cases/project_details?id=' + options.id)
}

//招聘信息
export function getRecruitContent (options) {
  return axios.get('/api/v1/web/recruitment_list', options)
}
export function getRecruitInfo (options) {
  return axios.get('/api/v1/web/recruitment_info/' + options.id)
}
//导航头部信息获取
export function getPhoneAndTime (options) {
  return axios.get('/api/v1/web/home_text', options)
}

// 获取站内信未读数量
export function getUnread (options) {
  return axios.get('/api/v1/web/letter/get_mail_count', options);
}

// 服务类型接口 top选项
export function getServiceMenu (options) {
  return axios.get('api/v1/web/cases/hospital_type', options);
}